// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1rRgN","col":"CardReaderDesc_col__Cj6yt","label":"CardReaderDesc_label__3qkco"};